import { isPremium as isPremiumAPI } from 'components/features/utils/userStatus';

// 現状loadingはありえないが、API取得に変えた場合に問題ないように定義しておく
type PremiumStatus = 'loading' | 'isNotPremium' | 'isPremium';

type State = {
  status: PremiumStatus;
};

export function usePremium(): [State] {
  const isPremium = isPremiumAPI();
  const state: State = {
    status: isPremium ? 'isPremium' : 'isNotPremium',
  };

  return [state];
}
